<template lang="pug">
     div.l-2-col
                        div.l-col-left
                            div.settings-section
                                switchItem.header.h1(label="wamfactory" type="wamFactory" inputName="wamfactory" :isSwitchActive="wamfactorySettings.wamfactory")

                                switchItem.section-item(v-if="wamfactorySettings.wamfactory" label="Bootstrap" type="wamFactory" inputName="bootstrap" :isSwitchActive="wamfactorySettings.bootstrap")

                                switchItem.section-item(v-if="wamfactorySettings.wamfactory" label="Hit export" type="wamFactory" inputName="logs" :isSwitchActive="wamfactorySettings.logs")

                                switchItem.section-item(v-if="wamfactorySettings.wamfactory && wamfactorySettings.bootstrap" label="Estimation feature" type="wamFactory" inputName="estimation" :isSwitchActive="wamfactorySettings.estimation")

                                switchItem.section-item(v-if="wamfactorySettings.wamfactory && userRole === 'webo_admin'" label="Wamfactory v2" type="wamFactory" inputName="wamFactoryv2" :isSwitchActive="wamfactorySettings.ruleVersion")

                            div.settings-section.mg-bt-0(v-if="wamfactorySettings.wamfactory")
                                SectionHeader.full-width-section-header(title="Namespace list")
                                    template(slot='action')
                                        .section-header--action
                                            button.btn-simple(:class="{'ui-disabled': isNamespaceEditing }" @click="displayNamespaceForm('create')") add
                                //- NAMESPACES TABLE
                                ElTable.namespace-table(
                                    row-key="id"
                                    :data="paginatedData",
                                    style="width:100%",
                                    :row-class-name="typeNavClassName",
                                    highlight-current-row,
                                    @row-click="handleRowClick"
                                    :default-sort='{ order: sortOrder, prop: sortBy }',
                                    @sort-change="handleSortChange"

                                    height="335")
                                    ElTableColumn(prop="id" label="Id" width="80" sortable :sort-method="sortByColumn('id')")
                                    ElTableColumn(prop="type" label="Type" width="80" sortable :sort-method="sortByColumn('type')")
                                    ElTableColumn(prop="label" label="Label"  sortable :sort-method="sortByColumn('label')")
                                        template(slot-scope="scope")
                                            div.full-width(:title="scope.row.label")
                                                p.is-truncate {{ scope.row.label }}
                                    ElTableColumn(width="40")
                                        template(slot-scope="scope")
                                            .actions-delete(@click.prevent="handleDeleteNamespace(scope.row.id)")
                                                svg-icon(name='trash' size='small' title="Delete")
                                    
                                ElPagination(
                                    background,
                                    layout='prev, pager, next, sizes',
                                    :total='namespaces.length',
                                    :page-size.sync='pageSize',
                                    :current-page.sync='currentPage',
                                    :page-sizes='[5, 10, 25, 50, 100]'
                                )

                        //- NAMESPACE FORM
                        div.l-col-left
                            div.settings-section(v-show="showNamespaceForm && wamfactorySettings.wamfactory")
                                SectionHeader(:title="namespaceFormTitle")
                                div.form-subsection
                                    div.form-label
                                        label Type
                                    select.form-select.big.square(class="ui-disabled" v-model="namespaceType")
                                        option(v-for="nmspType of namespaceTypes" v-bind:value="nmspType.value") {{ nmspType.label }}
                                div.form-subsection
                                    div.form-label__required
                                        label Label
                                    input.form-input(type="text" id="namespace-name" name="label" placeholder="Choose a nice label" v-validate="'max:200|required|ascii'" v-model="namespaceLabel" spellcheck="false")
                                    span.form-validate-error {{ errors.first('label') }}
                                div.form-subsection
                                    div.form-label__required
                                        label Pattern
                                    textarea(id="namespace-pattern" name="pattern" v-validate="'required|ascii'" v-model="namespacePattern" spellcheck="false")
                                    span.form-validate-error {{ errors.first('pattern') }}
                                div.l-flex-row--rev
                                    button.btn.btn--medium.btn--round(@click="cancel()") Cancel
                                    button.btn.btn--medium.btn--round.btn-rev.btn-save-audience(:class="{'ui-disabled': isSaveNamespaceDisabled }" @click="confirm()") {{ namespaceConfirmLabel }}
</template>
<script>
//components
import Table from '@/components/common/Table'
import SectionHeader from '@/components/common/SectionHeader'
import SwitchItem from '@/components/common/SwitchItem'
import tableOrderMixin from '@/mixins/tableOrderMixin'

//store
import { mapState, mapActions, mapMutations } from 'vuex'

import { isEmpty, isNil, find } from 'lodash'


export default {
    mixins: [tableOrderMixin],
    components: {
        SectionHeader,
        SwitchItem,
        Table
    },

    data() {
        return {
            wamfactory: 'active',
            showNamespaceForm: false,
            isNamespaceEditing: false,
            isNamespaceCreating: false,
            wamfactorySettings: {},
            namespaceType: 'CRM',
            namespaceTypes: [{ value: 'CRM', label: 'CRM' }],
            namespaceLabel: '',
            namespacePattern: '',
            namespaceId: null,
            currentPage: 1,
            pageSize: 10,
            sortOrder: 'ascending',
            defaultSortOrder: 'ascending',
            sortBy: 'id',
            processing: false
        }
    },

    watch: {
        uiWamFactoSettings: {
            handler: function(newValue) {
                this.wamfactorySettings = { ...newValue }
            },
            deep: true,
            immediate: true
        },
        wamfactorySettings: {
            handler: function(newValue) {
                if (!isNil(this.uiSettingName)) {
                    let params = {}
                    let label = ''
                    let requestNamespaceCreation = false
                    if (this.uiSettingName === 'wamfactory') {
                        if (newValue.wamfactory && !find(this.namespaces, namespace => namespace.type === 'NAV')) {
                            requestNamespaceCreation = true
                        }
                        params = {
                            wam_factory_activated: this.setsApiData(newValue.wamfactory)
                        }
                        label = 'WAM Factory '
                    } else if (this.uiSettingName === 'bootstrap') {
                        params = { bootstrap_custom_segment_available: this.setsApiData(newValue.bootstrap) }
                        label = 'Bootstrap custom segment '
                    } else if (this.uiSettingName === 'logs') {
                        params = { wamfactory_logs_activated: this.setsApiData(newValue.logs) }
                        label = 'Hit export '
                    } else if (this.uiSettingName === 'estimation') {
                        params = { rule_estimation_activated: this.setsApiData(newValue.estimation) }
                        label = 'Estimation feature '
                    } else if (this.uiSettingName === 'wamFactoryv2') {
                        params = { wamfactory_rules_version: this.setsApiDataWamfactoryRules(newValue.wamFactoryv2) }
                        label = 'Wamfactory v2 '
                    }
                    this.updateSettings({
                        params,
                        type: 'wamFactory',
                        notificationLabel: label,
                        requestNamespaceCreation: requestNamespaceCreation
                    })
                }
            },
            deep: true
        },
        namespaceId: {
            handler: function(newValue) {
                if (isNil(newValue)) this.isNamespaceEditing = false
            }
        }
    },

    computed: {
        ...mapState('account', {
            namespaces: state => state.namespaces,
            userRole: state => state.userRole
        }),

        ...mapState('ui/settings', {
            uiWamFactoSettings: state => state.wamFactory,
            uiSettingName: state => state.settingName,
        }),
        isSaveNamespaceDisabled() {
            return isEmpty(this.namespaceLabel) || isEmpty(this.namespacePattern) || this.errors.all().length > 0
        },
        namespaceFormTitle() {
            return this.isNamespaceEditing ? 'Edit namespace' : 'Create namespace'
        },
        namespaceConfirmLabel() {
            return this.isNamespaceEditing ? 'Edit' : 'Save'
        },
        
        paginatedData() {
            return this.paginate(this.namespaces)
        },
    },
    methods: {
        ...mapActions('data/settings', ['updateSettings']),

        ...mapActions('account', ['createNamespace', 'deleteNamespace', 'editNamespace']),

        ...mapMutations('notifications', ['setAddedNotification']),

        //- NAMESPACE
        displayNamespaceForm(action, namespace) {
            if (action === 'create') {
                if (this.isNamespaceCreating) this.resetNamespace()
                else this.showNamespaceForm = true
                this.isNamespaceCreating = !this.isNamespaceCreating
            } else if (action === 'edit') {
                if (namespace.type === 'NAV') {
                    this.setAddedNotification({ type: 'error', message: 'Can not edit default namespace' })
                } else if (this.isNamespaceEditing) {
                    if (this.namespaceId === namespace.id) {
                        this.resetNamespace()
                        this.isNamespaceEditing = false
                    } else {
                        this.namespaceId = namespace.id
                    }
                    this.initNamespaceEdit(namespace)
                } else if (!this.isNamespaceEditing) this.initNamespaceEdit(namespace)
            }
        },

        confirm() {
            if (this.isNamespaceEditing) this.handleEditNamespace()
            else if (this.isNamespaceCreating) this.handleCreateNamespace()
        },

        cancel() {
            if (this.isNamespaceCreating) this.isNamespaceCreating = !this.isNamespaceCreating
            else if (this.isNamespaceEditing) this.isNamespaceEditing = !this.isNamespaceEditing

            this.resetNamespace()
        },

        initNamespaceEdit(namespace) {
            this.namespacePattern = namespace.pattern
            this.namespaceLabel = namespace.label
            this.namespaceId = namespace.id
            this.showNamespaceForm = true
            this.isNamespaceEditing = true
        },

        resetNamespace() {
            this.$validator.reset()
            this.namespaceLabel = ''
            this.namespacePattern = ''
            this.namespaceId = null
            this.isEditing = false
            this.showNamespaceForm = false
        },

        handleCreateNamespace() {
            if (this.processing) return // Prevent multiple creation
            this.processing = true
            const params = {
                namespace_type: this.namespaceType,
                namespace: this.namespaceLabel,
                pattern: JSON.stringify([this.namespacePattern])
            }
            this.createNamespace(params).then(res => {
                if (res) this.resetNamespace()
                this.isNamespaceCreating = false
                this.processing = false
            })
        },

        handleEditNamespace() {
            if (this.processing) return // Prevent multiple request
            this.processing = true
            const params = {
                namespace_type: this.namespaceType,
                namespace: this.namespaceLabel,
                pattern: JSON.stringify([this.namespacePattern]),
                id: this.namespaceId
            }
            this.editNamespace(params).then(res => {
                if (res) this.resetNamespace()
                this.isNamespaceEditing = false
                this.processing = false
            })
        },

        async handleDeleteNamespace(id) {
            await this.deleteNamespace({ id })
            this.cancel()
        },

        setsApiData(data) {
            return data ? 'YES' : 'NO'
        },

        typeNavClassName({ row }) {
            const { type } = row
            return type === 'NAV' ? 'row-disabled' : ''
        },

        paginate(rows) {
            const trimStart = (this.currentPage - 1) * this.pageSize
            const trimEnd = trimStart + this.pageSize
            const sortOrder = this.sortOrder || this.defaultSortOrder
            if (sortOrder == 'descending') rows = [...rows].reverse()

            return rows.slice(trimStart, trimEnd)
        },

        sortByColumn(sortBy) {
            return (a, b) => b[sortBy] - a[sortBy]
        },
        setsApiDataWamfactoryRules(data) {
            return data ? 'V2' : 'V1'
        },

        handleRowClick(row) {
            if (row.type !== 'NAV') {
                this.displayNamespaceForm('edit', row)
            }
        }
    }
}
</script>
